module.exports = __webpack_public_path__ + "img/logo.7db56f21.svg";